import Blink from '@components/Blink'
import useTrackingUtils from '@components/Header/useTrackingUtils'
import { FunctionComponent } from 'react'
import styled, { css } from 'styled-components'

interface FirstLevelLinkProps {
  children: string
  href: string
}

const StyledFirstLevelLink = styled(Blink)`
  ${({
    theme: {
      colors: {
        grey: { grey_60, grey_80 },
      },
    },
  }) => css`
    color: ${grey_60};
    text-decoration: none;
    cursor: pointer;
    font-size: 16px;
    line-height: 20px;
    white-space: nowrap;
    &:hover {
      color: ${grey_80};
    }
  `}
`

const FirstLevelLink: FunctionComponent<FirstLevelLinkProps> = ({
  href,
  children,
}) => {
  const { navbarClickTrackingFn } = useTrackingUtils({
    title: children,
    url: href,
  })
  return (
    <StyledFirstLevelLink
      href={href}
      ariaLabel={children}
      onClick={navbarClickTrackingFn}>
      {children}
    </StyledFirstLevelLink>
  )
}

export default FirstLevelLink
